import React, { ReactNode } from "react";
import { Collapse, Skeleton } from "antd";
const { Panel } = Collapse;

function BlankCard({ style, loading, children, id = "", collapsible = false, title = "" }:
  { style?: React.CSSProperties; children: ReactNode; loading?: boolean, id?: string, collapsible?: boolean, title?: string; }) {
  if (collapsible) {
    return (
      <div className="card-wrapper" style={style} id={id}>
        <Skeleton active loading={loading}>
          <Collapse defaultActiveKey={["1"]} ghost>
            <Panel header={title} key="1" className="email-body-header">
              {children}
            </Panel>
          </Collapse>
        </Skeleton>
      </div>
    );
  } else {
    return (
      <div className="card-wrapper" style={style} id={id}>
        <Skeleton active loading={loading}>
          {children}
        </Skeleton>
      </div>
    );
  }
}

export default BlankCard;
